<template>
    <div class="support-popup" id="support-popup" >
        <div class="support-popup-row">
            <i class="popup-close"><img src="/assets/images/close-icon.svg"/></i>
            <div class="support-popup-top">
                <h3>{{ $t('support_us') }} </h3>
                <p>{{ $t('please_select_how_you_want_to_make_a_donation') }}</p>
            </div>
            <div class="credit-card">
                <div>
                    <div>
                        <p><img src="/assets/images/credit-card.svg" alt=""/> Credit Card</p>
                        <!--                <i><img src="/assets/images/share-icon.svg" alt=""/></i>-->
                    </div>

                    <br>
                    <footer style="padding-top: 0; background: unset">
                        <div class="footer-Newsletter-input">
                            <form :action="$store.state.hrefPrefix + '/support-us/pay'" method="post" ref="support" @submit.prevent="">
                                <input type="hidden" name="_token" :value="csrf">
                                <div class="Newsletter-input">
                                    <input type="number" :placeholder="$t('amount_usd')" name="amount"/>
                                    <button style="width: 100%" class="g-recaptcha"
                                            data-sitekey="6Ld3Xv8mAAAAAJSdwXb6BysaOps8-vQJMk9W_ej5"
                                            data-callback="submitSupport">
                                        {{ $t('SUPPORT') }}
                                    </button>
                                </div>
                            </form>

                        </div>
                    </footer>
                </div>


            </div>
            <div class="support-row">
                <div class="support-box">
                    <div class="support-info">
                        <i><img src="/assets/images/parteron-icon.svg" alt=""/></i>
                        <p>{{ $t('patreon') }}</p>
                    </div>
                    <span>
                        <a href="https://www.patreon.com/thecradlemedia" style="color: black" target="_blank">
                        <div>{{ $t('go_to_website') }}  <i><img src="/assets/images/share-icon.svg" alt=""/></i>
                            </div>
                        </a>
                    </span>
                </div>
                <div class="support-box">
                    <div class="support-info">
                        <i><img src="/assets/images/usdt-icon.svg" alt=""/></i>
                        <p>{{ $t('usdt') }}  <span>{{ $t('network') }}</span> <code id="p2">{{ $t('tron_trc20') }} </code></p>
                    </div>
                    <span @click="copyTRONAddressToClipboard">
                        <div>
                      {{ $t('copy_address') }}  <i><img src="/assets/images/copy-icon.svg" alt=""/></i>
                      </div>
                    </span>
                </div>
                <div class="support-box">
                    <div class="support-info">
                        <i><img src="/assets/images/btc-icon.svg" alt=""/></i>
                        <p>{{ $t('btc') }}  <span>{{ $t('network') }}</span> <code id="p1">{{ $t('btc_segwit') }} </code></p>
                    </div>
                    <span @click="copyBTCAddressToClipboard" ><div>{{ $t('copy_address') }} <i><img src="/assets/images/copy-icon.svg"
                                                                                      alt=""/></i></div></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SupportPopup",
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
    },

    methods: {
        copyTRONAddressToClipboard() {
            const address = 'TEyZtrShUqFdmHYeiqYyvMc3DnYWKrcSkV';

            navigator.clipboard.writeText(address);

            alert('Address copied to clipboard!');
        },

        copyBTCAddressToClipboard() {
            const address = 'bc1qd864czk7zrrvuf5uvm0f6fecfn78mt6w8e0356';

            navigator.clipboard.writeText(address);

            alert('Address copied to clipboard!');
        },
        submitSupport(response) {
            console.log(response)
            const form = this.$refs.support;
            form.submit();
        }
    },
    mounted() {
        window.submitSupport = this.submitSupport;
    }
}


</script>

<style scoped>

</style>
